import(/* webpackMode: "eager" */ "/app/src/app/(normal)/error.tsx");
